//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type InstagramUsername = Opaque<string, 'InstagramUsername'>;

function InstagramUsernameFactory(instagramUsername: string) {
  return instagramUsername as InstagramUsername;
}

const InstagramUsername = InstagramUsernameFactory;

export default InstagramUsername;
